import type { MapTool, MapClickEvent } from "../../../application/map/tools/types";
import type { ToolDeps } from "./types";
import { deletePointUseCase } from "../../../application/map/useCases/modifyPointUseCase";

export function makePointDeleteTool(deps: ToolDeps): MapTool {
	let jobId: string | null = null;

	return {
		id: "point-delete",
		label: "-Pt",
		cursor: "pointer",
		onActivate() {
			jobId = deps.getSelectedJobId();
			if (!jobId) {
				deps.showError("No job selected");
				deps.deactivateTool();
				return;
			}
		},
		onFeatureClick(featureId: string, _e: MapClickEvent) {
			if (!jobId) return;
			const currentJobId = jobId;

			const pointsFC = deps.getPointsFC(currentJobId);
			if (!pointsFC) return;

			// Ignore clicks on non-point features (e.g. boundary polygons)
			if (!pointsFC.features.some((f) => f.properties.sample_id === featureId)) return;

			const result = deletePointUseCase(pointsFC, featureId, (col) => deps.applyPoints(currentJobId, col));

			if (!result.ok) {
				deps.showError(result.error);
				return;
			}

			deps.undoStack.push(result.data.command);
		},
		onDeactivate() {
			jobId = null;
		},
	};
}
